<template>
  <v-form-create
    v-if="access.create_customer || target === 'update'"
    large
    name="customer"
    :top_title="'create_customer'"
    :ownHeader="target == 'update'"
  >
    <template v-slot:form_header>
      <v-toolbar flat class="pr-5 pl-2">
        <v-layout row class="px-2">
          <v-flex class="md6 px-2">
            <v-datetime-picker
              v-model="title_params.from_time"
              solo
              :label="$t('from_time')"
              v-bind:max="title_params.to_time"
            />
          </v-flex>
          <v-flex class="md6 px-2">
            <v-datetime-picker
              v-model="title_params.to_time"
              solo
              :label="$t('to_time')"
              v-bind:min="title_params.from_time"
            />
          </v-flex>
        </v-layout>
        <v-spacer />
        <v-btn icon color="primary" @click="editCustomerOpenDialog">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn
          v-if="!use_by_category"
          icon
          color="primary"
          @click="payCustomerDebtOpenDialog"
        >
          <v-icon>mdi-wallet-outline</v-icon>
        </v-btn>
        <v-btn icon @click="exportMethod">
          <v-icon>mdi-download</v-icon>
        </v-btn>
        <v-btn icon color="red" @click="exportPdfMethod">
          <v-icon>mdi-file-pdf</v-icon>
        </v-btn>
      </v-toolbar>

      <v-layout row class="px-3 mx-4" style="margin-top: 5px">
        <v-toolbar-title>
          {{ `${customer.first_name} ${customer.last_name}` }}
        </v-toolbar-title>
        <v-spacer />
        <p class="font-weight-bold">
          {{ $t("total_debt") }}:
          {{
            customer.debt
              ? (Math.round(customer.debt * 100) / 100).toLocaleString()
              : customer.debt
          }}
        </p>
      </v-layout>
    </template>

    <v-form v-model="is_valid">
      <v-card-text v-if="target == 'create'">
        <v-text-field
          v-model="customer.first_name"
          ref="first_name"
          :rules="[fieldRules.required]"
          :label="$t('first_name')"
        />
        <v-text-field v-model="customer.last_name" :label="$t('last_name')" />
        <v-text-field
          v-model="customer.email"
          :label="$t('email')"
          prepend-icon="mdi-email"
        />

        <v-text-field
          v-model="customer.phone_number"
          v-mask="mask"
          prefix="+"
          :label="$t('phone_number')"
          prepend-icon="mdi-phone"
          ref="phone_number"
          :rules="[fieldRules.required, fieldRules.employeePhone]"
        />
        <v-text-field
          v-model="customer.user_id"
          :label="$t('user_id')"
          prepend-icon="mdi-card-text"
          counter="30"
        />
        <v-text-field
          v-model="customer.note"
          :label="$t('note')"
          prepend-icon="mdi-note-text"
          counter="255"
        />
        <v-row>
          <v-col>
            <v-text-field
              v-model="customer.city"
              :label="$t('city')"
              prepend-icon="mdi-city"
            />
          </v-col>
          <v-col>
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :label="$t('birthday')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  v-bind:value="birthday_value"
                  ></v-text-field>
                </template>
              <v-date-picker
                v-model="customer.birthday"
                @input="menu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col>
            <v-select v-model="customer.gender" :items="genders" :label="$t('gender')"></v-select>
          </v-col>
        </v-row>
        <!-- <v-autocomplete
          v-model="customer.tariff_id"
          :label="$t('status')"
          v-bind:items="all_status"
          item-value="_id"
          item-text="name"
          ref="status"
          :rules="[fieldRules.required]"
        /> -->
        <v-list-item
          v-if="this.features.prices || feature_price"
          class="ma-0 pa-0"
        >
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">
              {{ $t("club_card") }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-switch v-model="customer.is_minimum_price" />
          </v-list-item-action>
        </v-list-item>
        <v-row>
          <v-col
            cols="5"
          >
            <v-select v-model="customer.user_type" :items="getUserTypes" :label="$t('user_type')"></v-select>
          </v-col>
          <v-col 
            v-if="customer.user_type == 'legal'"
            cols="7"
          >
          <v-text-field
            v-model="customer.inn"
              ref="inn"
              :rules="[fieldRules.required]"
              :label="$t('inn')"
            />
          </v-col>
        </v-row>

        <v-btn
          v-if="customer.user_type == 'legal' && contract_numbers.length > 0"
          text
          color="primary"
          @click="addOptionClicked"
        >
          <v-icon>mdi-plus-circle-outline</v-icon>add contract
        </v-btn>
        
        <v-radio-group
          hide-details
          v-model="default_contract_id"
        >

          <v-list-item
            v-for="(contract_number, index) in contract_numbers"
            v-bind:key="index"
          >
            <v-list-item-content class="ma-0">
              <v-layout row class="pa-0 ma-0">
                <v-flex md1 class="ma-0 pa-0 px-1">
                  <v-radio
                    :value="index"
                    style="margin-top: 20px !important; margin-left: 20px !important;"
                    :rules="[fieldRules.required]"
                  />
                </v-flex>

                <v-flex md6 class="ma-0 pa-0 px-1">
                  <v-text-field
                    v-model="contract_numbers[index].contractNo"
                    label="Contract №"
                    :rules="[fieldRules.required]"
                    @focus="$event.target.select()"
                    class="pa-0 ma-0 mt-2"
                  />
                </v-flex>

                <v-flex md5 class="ma-0 pa-0 px-1">
                  <v-datetime-picker
                    v-model="contract_numbers[index].contractDate"
                    :rules="[fieldRules.required]"
                    label="Contract date"
                  />
                </v-flex>
              </v-layout>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn
                icon
                @click="removeVariant(index)"
                style="margin-bottom: 20px !important"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>

        </v-radio-group>

        <v-btn
          v-if="customer.user_type == 'legal'"
          color="primary"
          @click="addOptionClicked"
          text
        >
          <v-icon>mdi-plus-circle-outline</v-icon>add contract
        </v-btn>
      </v-card-text>
      <v-card-text>
        <div
          v-if="
            use_by_category && this.customer && this.customer._id != undefined
          "
        >
          <v-data-table
            v-if="customer.receipts"
            disable-sort
            hide-default-footer
            :headers="receipt_headers"
            :items="customer.receipts"
            :items-per-page="10000"
          >
            <template v-slot:[`item.past_debt`]="{ item }">
              {{
                item.past_debt
                  ? (Math.round(item.past_debt * 100) / 100).toLocaleString()
                  : item.past_debt
              }}
            </template>
            <template v-slot:[`item.total_debt`]="{ item }">
              {{
                item.total_debt
                  ? (Math.round(item.total_debt * 100) / 100).toLocaleString()
                  : item.total_debt
              }}
            </template>
            <template v-slot:[`item.paid_debt`]="{ item }">
              {{
                item.paid_debt
                  ? (Math.round(item.paid_debt * 100) / 100).toLocaleString()
                  : item.paid_debt
              }}
            </template>
            <template v-slot:[`item.pay_debt`]="{ item }">
              <v-btn
                v-if="item.total_debt > item.paid_debt"
                color="success"
                icon
                @click="payDebt(item)"
              >
                <v-icon>mdi-wallet-outline</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </div>
        <!--
        <div v-else-if="this.customer && this.customer._id != undefined">
          <v-layout row px-2>
            <v-flex md2 px-2>
              <vuetify-money
                :value="customer.debt"
                :label="$t('debt')"
                :options="
                  currency.currency == 'usd' ? moneyOptionsUSD : moneyOptions
                "
                readonly
              ></vuetify-money>
            </v-flex>
            <v-flex md2 px-2>
              <vuetify-money
                :value="customer_past_debt"
                :label="$t('rest_debt')"
                :options="
                  currency.currency == 'usd' ? moneyOptionsUSD : moneyOptions
                "
                readonly
              ></vuetify-money>
            </v-flex>
            <v-flex md2 px-2>
              <vuetify-money
                v-model="paid"
                :label="$t('paid')"
                :options="
                  currency_type == 'uzs' ? moneyOptions : moneyOptionsUSD
                "
              ></vuetify-money>
            </v-flex>
            <v-flex md2 px-2>
              <v-checkbox
                v-model="getBack"
                :label="$t('get_back')"
              ></v-checkbox>
            </v-flex>
            <v-flex md2 px-2>
              <v-select
                v-model="amount_type"
                :label="$t('amount_type')"
                :items="[
                  { text: 'Cash', value: 'cash' },
                  { text: 'Card', value: 'card' },
                ]"
              ></v-select>
            </v-flex>
            <v-flex md2 px-2>
              <v-select
                v-model="currency_type"
                :label="$t('currency')"
                :items="[
                  { text: 'UZS', value: 'uzs' },
                  { text: 'USD', value: 'usd' },
                ]"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row px-2>
            <v-flex md12 px-2>
              <v-text-field v-model="comment" :label="$t('comment')" />
            </v-flex>
          </v-layout>
        </div>
        -->

        <v-list v-if="customer_id">
          <v-list-item-title class="font-weight-bold">{{
            $t("debt_history")
          }}</v-list-item-title>
          <v-data-table
            :headers="pay_history_headers"
            :items="debt_history"
            hide-default-footer
            disable-sort
            :items-per-page="debt_history_lenght"
            :loading="customer_debt_history_loading"
          >
            <template #[`item.receipt_no`]="{ item }">
              <v-text-field
                v-model="item.receipt_no"
                :append-icon="'mdi-chevron-down'"
                @click="OpenReceipt(item)"
                readonly
              />
            </template>
            <template v-slot:[`item.date`]="{ item }">
              {{ date_ddmmyy_hhmm(item.date) }}
            </template>
            <template v-slot:[`item.paid`]="{ item }">
              {{
                item.paid
                  ? (Math.round(item.paid * 100) / 100).toLocaleString()
                  : item.paid
              }}
            </template>
            <template v-slot:[`item.amount_type`]="{ item }">
              {{ $t(item.amount_type) }}
            </template>
            <template v-slot:[`item.currency`]="{ item }">
              {{ $t(item.currency) }}
            </template>
            <template v-slot:[`item.total_debt`]="{ item }">
              {{
                item.total_debt
                  ? (Math.round(item.total_debt * 100) / 100).toLocaleString()
                  : item.total_debt
              }}
            </template>
            <template v-slot:[`item.edit_item`]="{ item }">
              <v-btn icon v-if="item.sold_id" @click="updateSoldItem(item)">
                <v-icon color="primary">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <!-- <template v-slot:[`body.append`]>
              <tr class="grey lighten-2">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>
                  <b>Total:</b>
                </td>
                <td class="text-right">
                  <b>{{
                    customer.debt
                      ? (Math.round(customer.debt * 100) / 100).toLocaleString()
                      : customer.debt
                  }}</b>
                </td>
              </tr>
            </template> -->
            <template #footer>
              <v-pagination
                v-model="per_page"
                :length="page_length"
                total-visible="7"
              />
            </template>
          </v-data-table>
        </v-list>
      </v-card-text>
    </v-form>
    <template v-slot:action v-if="target == 'create'">
      <v-btn text @click="cancelClicked">{{ $t("cancel") }}</v-btn>
      <v-btn
        text
        color="primary"
        :loading="loading_customer"
        :disabled="saveDisabled"
        @click="save"
        >{{ $t("save") }}</v-btn
      >
    </template>
    <v-dialog v-model="pay_debt" :width="600" persistent>
      <v-card>
        <v-card-title>{{ $t("pay_debt") }}</v-card-title>
        <v-card-text>
          <v-layout row px-2>
            <v-flex md6 px-2>
              <vuetify-money
                v-model="debt_fill_data.paid_total"
                :label="$t('total_cost')"
                v-bind:options="
                  this.currency && this.currency.currency == 'usd'
                    ? moneyOptionsUSD
                    : moneyOptions
                "
                :maxValue="
                  current_category
                    ? current_category.total_debt - current_category.paid_debt
                    : null
                "
              />
            </v-flex>
            <v-flex md6 px-2>
              <v-select
                v-model="debt_fill_data.amount_type"
                :label="$t('amount_type')"
                :items="[
                  { text: 'Cash', value: 'cash' },
                  { text: 'Card', value: 'card' },
                ]"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row px-2>
            <v-flex md12 px-2>
              <v-text-field
                v-model="debt_fill_data.comment"
                :label="$t('comment')"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="pay_debt = false">{{ $t("cancel") }}</v-btn>
          <v-btn
            text
            color="primary"
            :loading="paid_total_loading"
            :disabled="!(debt_fill_data.paid_total > 0)"
            @click="payDebtConfirm"
            >{{ $t("pay_debt") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="edit_customer" :width="600" persistent>
      <v-card tile>
        <v-card-title>
          {{ $t("customer_detail") }}
        </v-card-title>
        <v-card-text>
          <v-form v-model="is_valid">
            <v-text-field
              v-model="customer_editing.first_name"
              ref="first_name"
              :rules="[fieldRules.required]"
              :label="$t('first_name')"
            />
            <v-text-field
              v-model="customer_editing.last_name"
              :label="$t('last_name')"
            />
            <v-text-field
              v-model="customer_editing.email"
              :label="$t('email')"
              prepend-icon="mdi-email"
            />

            <v-text-field
              v-model="customer_editing.phone_number"
              v-mask="mask"
              prefix="+"
              :label="$t('phone_number')"
              prepend-icon="mdi-phone"
              ref="phone_number"
              :rules="[fieldRules.required, fieldRules.employeePhone]"
            />
            <v-text-field
              v-model="customer_editing.user_id"
              :label="$t('user_id')"
              prepend-icon="mdi-card-text"
              counter="30"
            />
            <v-text-field
              v-model="customer_editing.note"
              :label="$t('note')"
              prepend-icon="mdi-note-text"
              counter="255"
            />
            <v-row>
              <v-col>
                <v-text-field
                  v-model="customer_editing.city"
                  :label="$t('city')"
                  prepend-icon="mdi-city"
                />
              </v-col>
              <v-col>
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="customer_editing.birthday"
                      :label="$t('birthday')"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="customer_editing.birthday"
                    @input="menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col>
                <v-select v-model="customer_editing.gender" :items="genders" :label="$t('gender')"></v-select>
              </v-col>
            </v-row>
            <!-- <v-autocomplete
              v-model="customer.tariff_id"
              :label="$t('status')"
              v-bind:items="all_status"
              item-value="_id"
              item-text="name"
              ref="status"
              :rules="[fieldRules.required]"
            /> -->
            <v-list-item
              v-if="this.features.prices || feature_price"
              class="ma-0 pa-0"
            >
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">
                  {{ $t("club_card") }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-switch v-model="customer.is_minimum_price" />
              </v-list-item-action>
            </v-list-item>
            <v-row>
              <v-col
                cols="5"
              >
                <v-select v-model="customer_editing.user_type" :items="getUserTypes" :label="$t('user_type')"></v-select>
              </v-col>
              <v-col 
                v-if="customer_editing.user_type == 'legal'"
                cols="7"
              >
                <v-text-field
                  v-model="customer_editing.inn"
                  ref="inn"
                  :rules="[fieldRules.required]"
                  :label="$t('inn')"
                />
              </v-col>
            </v-row>

            <v-btn
              v-if="customer_editing.user_type == 'legal' && contract_numbers.length > 0"
              text
              color="primary"
              @click="addOptionClicked"
            >
              <v-icon>mdi-plus-circle-outline</v-icon>add contract
            </v-btn>

            <v-radio-group
              hide-details
              v-model="default_contract_id"
            >
              <v-list-item
                v-for="(contract_number, index) in contract_numbers"
                v-bind:key="index"
              >
                <v-list-item-content class="ma-0">
                  <v-layout row class="pa-0 ma-0">
                    <v-flex md1 class="ma-0 pa-0 px-1">
                      <v-radio
                        :value="index"
                        style="margin-top: 15px !important;"
                        :rules="[fieldRules.required]"
                      />
                    </v-flex>

                    <v-flex md6 class="ma-0 pa-0 px-1">
                      <v-text-field
                        v-model="contract_numbers[index].contractNo"
                        label="Contract №"
                        :rules="[fieldRules.required]"
                        @focus="$event.target.select()"
                        class="pa-0 ma-0 mt-2"
                      />
                    </v-flex>

                    <v-flex md5 class="ma-0 pa-0 px-1">
                      <v-datetime-picker
                        v-model="contract_numbers[index].contractDate"
                        :rules="[fieldRules.required]"
                        label="Contract date"
                      />
                    </v-flex>
                  </v-layout>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn
                    icon
                    @click="removeVariant(index)"
                    style="margin-bottom: 20px !important"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-radio-group>

            <v-btn
              v-if="customer_editing.user_type == 'legal'"
              color="primary"
              @click="addOptionClicked"
              text
            >
              <v-icon>mdi-plus-circle-outline</v-icon>add contract
            </v-btn>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="edit_customer = false">{{ $t("cancel") }}</v-btn>
          <v-btn
            text
            color="primary"
            :loading="updating_profile"
            @click="updateCustomerProfile"
          >
            {{ $t("save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="pay_customer_debt" :width="600" persistent>
      <v-card tile>
        <v-card-title>{{ $t("pay_customer_debt") }}</v-card-title>
        <v-card-text>
          <v-layout row px-2>
            <v-flex md6 px-2>
              <vuetify-money
                :value="customer_pay_debt.debt"
                :label="$t('debt')"
                :options="
                  currency.currency == 'usd' ? moneyOptionsUSD : moneyOptions
                "
                readonly
              ></vuetify-money>
            </v-flex>
            <v-flex md6 px-2>
              <vuetify-money
                :value="customer_past_debt"
                :label="$t('rest_debt')"
                :options="
                  currency.currency == 'usd' ? moneyOptionsUSD : moneyOptions
                "
                readonly
              ></vuetify-money>
            </v-flex>
          </v-layout>
          <v-layout row px-2>
            <v-flex md6 px-2>
              <vuetify-money
                v-model="paid"
                :label="$t('paid')"
                :options="
                  currency_type == 'usd' ? moneyOptionsUSD : moneyOptions
                "
              ></vuetify-money>
            </v-flex>
            <v-flex md6 px-2>
              <v-checkbox
                v-model="getBack"
                :label="$t('get_back')"
              ></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout row px-2>
            <v-flex md6 px-2>
              <v-select
                v-model="amount_type"
                :label="$t('amount_type')"
                :items="[
                  { text: 'Cash', value: 'cash' },
                  { text: 'Card', value: 'card' },
                ]"
              ></v-select>
            </v-flex>
            <v-flex md6 px-2>
              <v-select
                v-model="currency_type"
                :label="$t('currency')"
                :items="transfer_currencies"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row px-2>
            <v-flex md12 px-2>
              <v-text-field v-model="comment" :label="$t('comment')" />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="pay_customer_debt = false">{{
            $t("cancel")
          }}</v-btn>
          <v-btn
            text
            color="primary"
            @click="payCostumerDebt"
            :loading="updating_profile"
            >{{ $t("save") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="edit_sold_item" :width="600" persistent>
      <v-card tile>
        <v-card-title>{{ $t("edit_sold_item") }}</v-card-title>
        <v-card-text>
          <p class="font-weight-bold title">
            {{ current_sold_item.product_name }}
          </p>
          <v-text-field
            v-model.number="current_sold_item.value"
            type="number"
            :label="$t('value')"
            @focus="$event.target.select()"
          />
          <v-text-field
            v-model.number="current_sold_item.price"
            type="number"
            :label="$t('price')"
            @focus="$event.target.select()"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="edit_sold_item = false">{{ $t("cancel") }}</v-btn>
          <v-btn
            text
            color="primary"
            :loading="loading_sold_item"
            @click="soldItemUpdate"
            >{{ $t("save") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="openReceiptDialog" persistent width="700">
      <v-card>
        <v-card-title>
          <span class="text-h5"
            >{{ $t("receipt") }}:{{ OpenReceiptNumber }}</span
          >
        </v-card-title>
        <v-data-table
          :headers="open_receipt_headers"
          :items="open_receipt_items"
          hide-default-footer
          :items-per-page="10000"
        >
          <template #[`item.price`]="{ item }">
            <v-text-field
              v-model.number="item.price"
              type="number"
              :ref="'price' + item._id"
              @focus="$event.target.select()"
              class="text-right"
              autocomplete="off"
            />
          </template>
          <template #[`item.value`]="{ item }">
            <v-text-field
              v-model.number="item.value"
              type="number"
              :ref="'value' + item._id"
              @focus="$event.target.select()"
              class="text-right"
              autocomplete="off"
            />
          </template>
        </v-data-table>
        <v-card-actions>
          <v-spacer />
          <b>{{ $t("total") }}</b
          >:<b>{{ openReceiptTotal.toLocaleString() }}</b>
        </v-card-actions>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="openReceiptDialog = false" color="primary"
            >cancel</v-btn
          >
          <v-btn
            :loading="loading_receipt_open"
            text
            @click="saveOpenReceiptClicked"
            color="primary"
            >save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form-create>
  <error404 v-else></error404>
</template>

<script>
import Currency from "../../mixins/settings/currency";
import Userable from "../../mixins/userable";

export default {
  name: "customer-detail",
  mixins: [Userable, Currency],
  data: () => ({
    mask: "### (##) ### ## ##",
    customer: {
      first_name: "",
      last_name: "",
      receipts: [],
      debt_pay_history: [],
      is_minimum_price: false,
      tariff_id: null,
      city:"",
      birthday: null,
      gender:"not_set",
      user_type:"natural",
      inn: "",
      contract_numbers: [],
    },
    all_status: [],
    customer_editing: {
      first_name: "",
      last_name: "",
      user_type:"natural",
    },
    customer_pay_debt: {
      debt: 0,
    },
    debt_fill_data: {
      paid_total: 0,
      comment: "",
      amount_type: "cash",
    },
    paid: 0,
    amount_type: "cash",
    currency_type: "uzs",
    comment: "",
    is_valid: false,
    getBack: false,
    pay_debt: false,
    current_category: {},
    paid_total_loading: false,
    loading_customer: false,
    exportLink: "",
    edit_customer: false,
    pay_customer_debt: false,
    updating_profile: false,
    debt_history: [],
    debt_history_lenght: 1000,
    title_params: {
      from_time: new Date(new Date().setDate(new Date().getDate() - 7))
        .toISOString()
        .substr(0, 10),
      to_time: new Date(new Date().setDate(new Date().getDate()))
        .toISOString()
        .substr(0, 10),
    },
    customer_debt_history_loading: false,
    loading_sold_item: false,
    edit_sold_item: false,
    feature_price: false,
    current_sold_item: {
      product_name: "",
      value: 0,
    },
    openReceiptDialog: false,
    open_receipt_items: [],
    OpenReceiptNumber: "",
    current_open_receipt_sold_item: {},
    openReceiptId: "",
    loading_receipt_open: false,
    per_page: 1,
    page_length: 0,
    limit: 10,
    menu: false,
    contract_numbers: [],
    default_contract_id: 0,
  }),
  computed: {
    birthday_value() {
      if (this.customer.birthday) return this.date_ddmmyy(new Date(this.customer.birthday).getTime());
      return null;
    },
    getUserTypes(){
      return [
        {
          text: this.$t("natural_user"),
          value: "natural",
        },
        {
          text: this.$t("legal_user"),
          value: "legal",
        }
      ];
    },
    genders(){
      return [
        {
          text: this.$t("male"),
          value: "male",
        },
        {
          text: this.$t("female"),
          value: "female",
        }
      ];
    },
    openReceiptTotal() {
      var sum = 0;
      for (const item of this.open_receipt_items) {
        sum += item.price * item.value;
      }
      return sum;
    },
    customer_past_debt() {
      if (this.currency_type == this.currency.currency) {
        return this.getBack
          ? +this.customer_pay_debt.debt + +this.paid
          : this.customer_pay_debt.debt - this.paid;
      } else {
        const curr_value = this.currency.value ? this.currency.value : 1;
        const paid =
          this.currency_type == "usd"
            ? this.paid * curr_value
            : this.paid / curr_value;
        return this.getBack
          ? +this.customer_pay_debt.debt + paid
          : this.customer_pay_debt.debt - paid;
      }
    },
    target() {
      return this.$route.params["target"];
    },
    customer_id() {
      return this.$route.query.id;
    },
    form() {
      return {
        first_name: this.customer.first_name,
        phone_number: this.customer.phone_number,
      };
    },
    saveDisabled() {
      let formHasErrors = false || !this.is_valid;
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) formHasErrors = true;
      });
      return formHasErrors;
    },
    receipt_headers() {
      return [
        { text: this.$t("category_name"), value: "category_name" },
        {
          text: this.$t("past_debt"),
          value: "past_debt",
          width: 120,
          align: "right",
        },
        {
          text: this.$t("total_debt"),
          value: "total_debt",
          width: 120,
          align: "right",
        },
        {
          text: this.$t("paid_debt"),
          value: "paid_debt",
          width: 120,
          align: "right",
        },
        { text: null, value: "pay_debt", width: 50, align: "center" },
      ];
    },
    use_by_category() {
      return this.user_access && this.user_access.client_debt_by_category;
    },
    pay_history_headers() {
      return [
        { text: this.$t("date"), value: "date" },
        { text: this.$t("receipt_no"), value: "receipt_no", width: 200 },
        // { text: this.$t("product_name"), value: "product_name" },
        // { text: this.$t("value"), value: "value" },
        // { text: this.$t("reminder"), value: "reminder" },
        // { text: this.$t("price"), value: "price" },
        // { text: this.$t("currency"), value: "currency" },
        // { text: this.$t("currency_value"), value: "currency_value" },
        // { text: this.$t("by_name"), value: "by_name" },
        { text: this.$t("comment"), value: "comment" },
        { text: this.$t("paid"), value: "paid" },
        { text: this.$t("total_price"), value: "total_price" },
        { text: this.$t("total_debt"), value: "total_debt", align: "right" },
        { text: null, value: "edit_item", align: "right" },
      ];
    },
    open_receipt_headers() {
      return [
        {
          text: this.$t("product_name"),
          value: "product_name",
          sortable: false,
        },
        { text: this.$t("price"), value: "price", sortable: false },
        { text: this.$t("value"), value: "value", sortable: false },
        // { text: null, value: "edit_item_open_receipt", align: "right" },
      ];
    },
  },
  watch: {
    currency: {
      deep: true,
      handler() {
        if (this.currency && this.currency.currency) {
          this.currency_type = this.currency.currency;
        }
      },
    },
    title_params: {
      deep: true,
      handler() {
        this.getCustomerDebtHistory();
      },
    },
    per_page() {
      const query = {
        ...this.$route.query,
        page: this.per_page,
      };
      this.$router.push({ path: this.$route.path, query: query });
      this.getCustomerDebtHistory();
    },
  },
  methods: {
    async OpenReceipt(item) {
      this.openReceiptDialog = true;
      this.OpenReceiptNumber = item.receipt_no;
      this.open_receipt_items = item.sold_item_list;
      this.openReceiptId = item._id;
    },
    async saveOpenReceiptClicked() {
      const sold_item_list = [];
      for (const item of this.open_receipt_items) {
        sold_item_list.push({
          price: item.price,
          value: item.value,
          sold_id: item._id,
        });
      }
      this.current_open_receipt_sold_item = {
        customer_id: this.customer._id,
        receipt_id: this.openReceiptId,
        sold_item_list: sold_item_list,
      };
      this.loading_receipt_open = true;
      try {
        const result = this.$communicator.then(
          this,
          await this.$communicator("sold_item_group_update", {
            params: this.current_open_receipt_sold_item,
          })
        );
        if (result) {
          this.loading_receipt_open = false;
          this.getCustomer();
          this.getCustomerDebtHistory();
          this.$toast.success("Success", { timeout: 2000 });
        }
      } catch (error) {
        if (error.name == "Error") {
          this.loading_receipt_open = false;
          this.$toast.error("Error", { timeout: 2000 });
        }
      }

      this.openReceiptDialog = false;
    },
    async getFeature() {
      const feature = this.$communicator.then(
        this,
        await this.$communicator("features")
      );
      this.feature_price = feature?.prices;
    },
    updateSoldItem(item) {
      this.current_sold_item = {
        product_name: item.product_name,
        value: item.value < 0 ? item.value * -1 : item.value,
        sold_id: item.sold_id,
        receipt_id: item.receipt_id,
        price: item.price,
        customer_id: this.customer._id,
      };
      this.edit_sold_item = true;
    },
    async soldItemUpdate() {
      this.loading_sold_item = true;
      const result = this.$communicator.then(
        this,
        await this.$communicator("sold_item_update", {
          params: this.current_sold_item,
        })
      );
      if (result) {
        this.edit_sold_item = false;
        this.getCustomer();
        this.getCustomerDebtHistory();
      }
      this.loading_sold_item = false;
    },
    async updateCustomerProfile() {
      this.updating_profile = true;
      this.customer_editing.phone_number =
        this.$communicator.clear_phone_number_second(
          this.customer_editing.phone_number
        );
      this.customer_editing.contract_numbers = this.contract_numbers;

      for (let i = 0; i < this.customer_editing.contract_numbers.length; i++) {
        this.customer_editing.contract_numbers[i].isDefault = this.default_contract_id === i;
        if(new Date(this.customer_editing.contract_numbers[i].contractDate).toString() === 'Invalid Date') {
          this.updating_profile = false;
          return this.$toast.error(
            `${this.customer_editing.contract_numbers[i].contractNo} contract date is invalid`, 
            { timeout: 2000 },
          );
        }
      }
      const result = this.$communicator.then(
        this,
        await this.$communicator("update_customer", {
          arguments: [this.customer_id],
          params: {
            first_name: this.customer_editing.first_name,
            last_name: this.customer_editing.last_name,
            note: this.customer_editing.note,
            phone_number: this.customer_editing.phone_number,
            email: this.customer_editing.email,
            paid: 0,
            user_id: this.customer_editing.user_id,
            is_minimum_price: this.customer.is_minimum_price,
            user_type: this.customer_editing.user_type,
            inn: this.customer_editing.inn,
            contract_numbers: this.customer_editing.contract_numbers,
          },
        })
      );
      if (result) {
        this.edit_customer = false;
        this.getCustomer();
      }
      this.updating_profile = false;
    },
    async payCostumerDebt() {
      this.updating_profile = true;
      this.customer_pay_debt.phone_number =
        this.$communicator.clear_phone_number_second(
          this.customer_pay_debt.phone_number
        );
      const result = this.$communicator.then(
        this,
        await this.$communicator("update_customer", {
          arguments: [this.customer_id],
          params: {
            first_name: this.customer_pay_debt.first_name,
            last_name: this.customer_pay_debt.last_name,
            note: this.customer_pay_debt.note,
            phone_number: this.customer_pay_debt.phone_number,
            email: this.customer_pay_debt.email,
            paid: this.getBack ? -1 * this.paid : this.paid,
            comment: this.comment,
            amount_type: this.amount_type,
            currency: this.currency_type,
          },
        })
      );
      if (result) {
        this.pay_customer_debt = false;
        this.customer_pay_debt = { debt: 0 };
        this.paid = 0;
        this.amount_type = "cash";
        this.currency_type = "uzs";
        this.comment = "";
        this.getBack = false;
        this.getCustomer();
        this.getCustomerDebtHistory();
      }
      this.updating_profile = false;
    },
    async getCustomerDebtHistory() {
      this.customer_debt_history_loading = true;
      const from_time = new Date(this.title_params.from_time).getTime();
      const to_time = new Date(
        new Date().setDate(new Date().getDate(this.title_params.to_time) + 1)
      ).getTime();
      const result = await this.$communicator("customer_debt_history", {
        query: { limit: this.limit, page: this.per_page },
        params: {
          customer_id: this.customer_id,
          from_time: from_time,
          to_time: to_time,
        },
      });
      if (result.data.data instanceof Array) {
        this.debt_history = result?.data?.data;
        this.debt_history_lenght = result?.data?.data?.length;
        this.page_length = Math.ceil(result?.data?.total / this.limit);
      }
      this.customer_debt_history_loading = false;
    },
    editCustomerOpenDialog() {
      this.customer_editing = this.$copy(this.customer);
      this.edit_customer = true;
    },
    payCustomerDebtOpenDialog() {
      this.customer_pay_debt = this.$copy(this.customer);
      this.pay_customer_debt = true;
    },
    exportMethod() {
      this.$communicator.downloadDocument(this.exportLink, `history.xls`);
    },
    exportPdfMethod() {
      const from_time = new Date(this.title_params.from_time).getTime();
      const to_time = new Date(
        new Date().setDate(new Date().getDate(this.title_params.to_time) + 1)
      ).getTime();
      const exportLink = `customer-debt-history-pdf/${this.computed_user.token}/${this.customer_id}/${from_time}/${to_time}/history.pdf`;
      this.$communicator.downloadDocument(exportLink, `history.pdf`);
    },
    cancelClicked() {
      this.$router.push("/customers").catch(() => {});
    },
    async getCustomer() {
      const res = this.$communicator.then(
        this,
        await this.$communicator("customer_get_by_id", {
          arguments: [this.customer_id],
        })
      );
      if (res) {
        res.phone_number = this.$communicator.make_phone_number_second(
          res.phone_number
        );
        if (!res.debt) {
          res.debt = 0;
        }
        this.customer = res;
        this.contract_numbers = Array.isArray(res.contract_numbers) ? res.contract_numbers : []
      } else {
        this.$router.push("/customers").catch(() => {});
      }
    },
    async save() {
      this.loading_customer = true;
      if (this.customer.birthday) {
        this.date_ddmmyy(new Date(this.customer.birthday).getTime());
      } else {
        this.customer.birthday = ""
      }

      this.customer.contract_numbers = this.contract_numbers
      const params = this.$copy(this.customer);
      params.phone_number = this.$communicator.clear_phone_number_second(
        params.phone_number
      );
      params.contract_numbers = params.contract_numbers.map(contract_number => ({
        isDefault: false,
        contractNo: contract_number.contractNo,
        contractDate: contract_number.contractDate,
      }))

      for (let i = 0; i < params.contract_numbers.length; i++) {
        params.contract_numbers[i].isDefault = this.default_contract_id === i;
        if(new Date(params.contract_numbers[i].contractDate).toString() === 'Invalid Date') {
          this.loading_customer = false;
          return this.$toast.error(
            `${params.contract_numbers[i].contractNo} contract date is invalid`, 
            { timeout: 2000 },
          );
        }
      }

      if (this.target != "update") {
       const res = this.$communicator.then(
          this,
          await this.$communicator("create_customer", {
            params,
          })
        );

        if(res.statusCode >= 400) {
          this.$toast.error("Failed", { timeout: 2000 });
        } else {
          this.$toast.success("Success", { timeout: 2000 });
        }
        this.$router.push("/customers").catch(() => {});
      } else {
        this.$communicator.then(
          this,
          await this.$communicator("update_customer", {
            arguments: [this.customer_id],
            params: {
              first_name: params.first_name,
              last_name: params.last_name,
              note: params.note,
              phone_number: params.phone_number,
              email: params.email,
              paid: this.getBack ? -1 * this.paid : this.paid,
              amount_type: this.amount_type,
              currency: this.currency_type,
              comment: this.comment,
              user_type: params.user_type,
              contract_numbers: params.contract_numbers,
            },
          })
        );
        this.paid = 0;
        this.$router.push("/customers").catch(() => {});
      }
      this.loading_customer = false;
    },
    async payDebt(item) {
      this.current_category = item;
      this.pay_debt = true;
      this.debt_fill_data = {
        paid_total: 0,
        comment: "",
        amount_type: "cash",
      };
    },
    async payDebtConfirm() {
      this.paid_total_loading = true;
      const result = this.$communicator.then(
        this,
        await this.$communicator("customer_pay_for_debt", {
          params: {
            client_id: this.customer_id,
            category_id: this.current_category._id,
            paid: this.debt_fill_data.paid_total,
            comment: this.debt_fill_data.comment,
            amount_type: this.debt_fill_data.amount_type,
          },
        })
      );
      if (result) {
        await this.getCustomer();
        this.pay_debt = false;
      }
      this.paid_total_loading = false;
    },
    addOptionClicked() {
      if (this.contract_numbers.length < 5) {
        this.contract_numbers.push({
          isDefault: this.contract_numbers.length === 0,
          contractNo: '',
          contractDate: '',
        });
      }
      this.customer.contract_numbers = this.contract_numbers
      this.customer_editing.contract_numbers = this.contract_numbers
    },
    removeVariant(rmInd) {
      this.contract_numbers = this.contract_numbers.filter((_v, currIndx) => currIndx !== rmInd);
      this.customer.contract_numbers = this.contract_numbers
      this.customer_editing.contract_numbers = this.contract_numbers
    },
  },
  mounted() {
    window.addEventListener(
      "offline",
      () => (
        this.$toast.error("Offline", { timeout: 2000 }),
        (this.loading_receipt_open = false)
      )
    );
    window.addEventListener(
      "online",
      () => (
        this.$toast.success("Online", { timeout: 2000 }),
        (this.loading_receipt_open = false),
        this.getCustomerDebtHistory()
      )
    );
    const query = this.$route.query;
    if (query && query.page && query.page != "NaN") {
      this.per_page = parseInt(query.page);
      this.getCustomerDebtHistory();
    }
    this.getFeature();
    if (this.target == "update") {
      this.getCustomer();
      this.getCustomerDebtHistory();
      // this.getStatus();
    }
    if (this.computed_user) {
      this.exportLink = `customer-debt-history/${this.computed_user.token}/${this.customer_id}/history.xls`;
    }
  },
  beforeMount() {
    this.$router.go(1);
    this.access = this.$store.state.access;
    this.features = this.$store.state.feature;
    // this.getStatus();
  },
};
</script>
